import React from 'react';

import { IContentItemAnalytics } from '../../../../components/content-item';
import ScrollingSection from '../../../../components/scrolling-section';
import { myListTitle } from '../../../../i18n/translations';
import { IUserLibraryMyListResponseOK } from '@ifit/gateway-wolf-athenaeum-service';

interface IProps {
  myList: IUserLibraryMyListResponseOK;
  isLoading: boolean;
  href?: string;
  title?: string;
  analytics?: IContentItemAnalytics;
  reload?: () => void;
  isError?: boolean;
}

const ContinueSeries: React.FC<IProps> = ({
  myList,
  isLoading,
  href,
  title,
  analytics,
  reload,
  isError,
}) => {
  let route = href;

  if (!route && !isLoading) {
    route = '/my-list';
  }

  return (
    <ScrollingSection
      reload={reload}
      showCategory
      title={title || myListTitle()}
      listData={myList}
      route={route}
      isLoading={isLoading}
      analytics={analytics}
      isError={isError}
    />
  );
};

export default ContinueSeries;
